var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtLine = function SvgAtLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B7B7B",
    d: "M16 10a6 6 0 1 0-2.671 4.993l.832 1.248A7.5 7.5 0 1 1 17.5 10v1.124a2.624 2.624 0 0 1-4.797 1.475A3.75 3.75 0 1 1 12.25 7h1.5v4.125a1.125 1.125 0 1 0 2.25 0zm-6-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5"
  })));
};
export default SvgAtLine;